import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'pdf-viewer-modal',
	templateUrl: './pdf-viewer-modal.component.html',
	styleUrls: ['./pdf-viewer-modal.component.scss'],
	standalone: false
})
export class PdfViewerModalComponent implements OnInit {
	@Input() documentUrl: string;
	@Input() modalHeaderTitle: string;
	sanitizedUrl: SafeResourceUrl;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnInit() {
		this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentUrl);
	}

	dismiss() {
		const modal = document.querySelector('ion-modal');
		if (modal) {
			modal.dismiss();
		}
	}
}
